// Generated from libphonenumber-js metadata already installed in the legacy repo.
// Stores possible national-number lengths per country so CRM phone validation
// can stay local without adding a runtime dependency.
export const PHONE_COUNTRY_NATIONAL_LENGTHS = {
  AC: [5, 6],
  AD: [6, 8, 9],
  AE: [5, 6, 7, 8, 9, 10, 11, 12],
  AF: [9],
  AG: [10],
  AI: [10],
  AL: [6, 7, 8, 9],
  AM: [8],
  AO: [9],
  AR: [10, 11],
  AS: [10],
  AT: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  AU: [5, 6, 7, 8, 9, 10, 12],
  AW: [7],
  AX: [5, 6, 7, 8, 9, 10, 11, 12],
  AZ: [9],
  BA: [8, 9],
  BB: [10],
  BD: [6, 7, 8, 9, 10],
  BE: [8, 9],
  BF: [8],
  BG: [6, 7, 8, 9, 12],
  BH: [8],
  BI: [8],
  BJ: [8, 10],
  BL: [9],
  BM: [10],
  BN: [7],
  BO: [8, 9],
  BQ: [7],
  BR: [8, 9, 10, 11],
  BS: [10],
  BT: [7, 8],
  BW: [7, 8, 10],
  BY: [6, 7, 8, 9, 10, 11],
  BZ: [7, 11],
  CA: [7, 10],
  CC: [6, 7, 8, 9, 10, 12],
  CD: [7, 8, 9, 10],
  CF: [8],
  CG: [9],
  CH: [9, 12],
  CI: [10],
  CK: [5],
  CL: [9, 10, 11],
  CM: [8, 9],
  CN: [7, 8, 9, 10, 11, 12],
  CO: [8, 10, 11],
  CR: [8, 10],
  CU: [6, 7, 8, 10],
  CV: [7],
  CW: [7, 8],
  CX: [6, 7, 8, 9, 10, 12],
  CY: [8],
  CZ: [9, 10, 11, 12],
  DE: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  DJ: [8],
  DK: [8],
  DM: [10],
  DO: [10],
  DZ: [8, 9],
  EC: [8, 9, 10, 11],
  EE: [7, 8, 10],
  EG: [8, 9, 10],
  EH: [9],
  ER: [7],
  ES: [9],
  ET: [9],
  FI: [5, 6, 7, 8, 9, 10, 11, 12],
  FJ: [7, 11],
  FK: [5],
  FM: [7],
  FO: [6],
  FR: [9],
  GA: [7, 8],
  GB: [7, 9, 10],
  GD: [10],
  GE: [9],
  GF: [9],
  GG: [7, 9, 10],
  GH: [8, 9],
  GI: [8],
  GL: [6],
  GM: [7],
  GN: [8, 9],
  GP: [9],
  GQ: [9],
  GR: [10, 11, 12],
  GT: [8, 11],
  GU: [10],
  GW: [7, 9],
  GY: [7],
  HK: [5, 6, 7, 8, 9, 11],
  HN: [8, 11],
  HR: [7, 8, 9],
  HT: [8],
  HU: [8, 9],
  ID: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
  IE: [7, 8, 9, 10],
  IL: [7, 8, 9, 10, 11, 12],
  IM: [10],
  IN: [8, 9, 10, 11, 12, 13],
  IO: [7],
  IQ: [8, 9, 10],
  IR: [4, 5, 6, 7, 10],
  IS: [7, 9],
  IT: [6, 7, 8, 9, 10, 11, 12],
  JE: [10],
  JM: [10],
  JO: [8, 9],
  JP: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
  KE: [7, 8, 9, 10],
  KG: [9, 10],
  KH: [8, 9, 10],
  KI: [5, 8],
  KM: [7],
  KN: [10],
  KP: [8, 10],
  KR: [5, 6, 8, 9, 10, 11, 12, 13, 14],
  KW: [7, 8],
  KY: [10],
  KZ: [10, 14],
  LA: [8, 9, 10],
  LB: [7, 8],
  LC: [10],
  LI: [7, 9],
  LK: [9],
  LR: [7, 8, 9],
  LS: [8],
  LT: [8],
  LU: [4, 5, 6, 7, 8, 9, 10, 11],
  LV: [8],
  LY: [9],
  MA: [9],
  MC: [8, 9],
  MD: [8],
  ME: [8, 9],
  MF: [9],
  MG: [9],
  MH: [7],
  MK: [8],
  ML: [8],
  MM: [6, 7, 8, 9, 10],
  MN: [8, 9, 10],
  MO: [7, 8],
  MP: [10],
  MQ: [9],
  MR: [8],
  MS: [10],
  MT: [8],
  MU: [7, 8, 10],
  MV: [7, 10],
  MW: [7, 9],
  MX: [10],
  MY: [8, 9, 10],
  MZ: [8, 9],
  NA: [8, 9],
  NC: [6],
  NE: [8],
  NF: [6],
  NG: [10, 11, 12, 13, 14],
  NI: [8],
  NL: [5, 6, 7, 8, 9, 10, 11],
  NO: [5, 8],
  NP: [8, 10, 11],
  NR: [7],
  NU: [4, 7],
  NZ: [5, 6, 7, 8, 9, 10],
  OM: [7, 8, 9],
  PA: [7, 8, 10, 11],
  PE: [8, 9],
  PF: [6, 8, 9],
  PG: [7, 8],
  PH: [6, 8, 9, 10, 11, 12, 13],
  PK: [8, 9, 10, 11, 12],
  PL: [6, 7, 8, 9, 10],
  PM: [6, 9],
  PR: [10],
  PS: [8, 9, 10],
  PT: [9],
  PW: [7],
  PY: [6, 7, 8, 9, 10, 11],
  QA: [7, 8, 9, 11],
  RE: [9],
  RO: [6, 9],
  RS: [6, 7, 8, 9, 10, 11, 12],
  RU: [10, 14],
  RW: [8, 9],
  SA: [9, 10],
  SB: [5, 7],
  SC: [7],
  SD: [9],
  SE: [6, 7, 8, 9, 10, 12],
  SG: [8, 10, 11],
  SH: [4, 5],
  SI: [5, 6, 7, 8],
  SJ: [5, 8],
  SK: [6, 7, 9],
  SL: [8],
  SM: [8, 10],
  SN: [9],
  SO: [6, 7, 8, 9],
  SR: [6, 7],
  SS: [9],
  ST: [7],
  SV: [7, 8, 11],
  SX: [10],
  SY: [8, 9],
  SZ: [8, 9],
  TA: [4],
  TC: [10],
  TD: [8],
  TG: [8],
  TH: [8, 9, 10, 13],
  TJ: [9],
  TK: [4, 5, 6, 7],
  TL: [7, 8],
  TM: [8],
  TN: [8],
  TO: [5, 7],
  TR: [7, 10, 12, 13],
  TT: [10],
  TV: [5, 6, 7],
  TW: [7, 8, 9, 10, 11],
  TZ: [9],
  UA: [9, 10],
  UG: [9],
  US: [10],
  UY: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  UZ: [9],
  VA: [6, 7, 8, 9, 10, 11, 12],
  VC: [10],
  VE: [10],
  VG: [10],
  VI: [10],
  VN: [7, 8, 9, 10],
  VU: [5, 7],
  WF: [6, 9],
  WS: [5, 6, 7, 10],
  XK: [8, 9, 10, 11, 12],
  YE: [7, 8, 9],
  YT: [9],
  ZA: [5, 6, 7, 8, 9, 10],
  ZM: [9],
  ZW: [5, 6, 7, 8, 9, 10],
} as const;

export type PhoneCountryWithLengths =
  keyof typeof PHONE_COUNTRY_NATIONAL_LENGTHS;
